export enum CourseInformationTab {
  MODULES = "modules",
  ANALYTICS = "analytics",
  ROSTER_MANAGEMENT = "roster-management",
  COMMUNITY = "community",
  ANNOUNCEMENTS = "announcements",
  SETTINGS = "settings",
}
